import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@shared/shared/shared.module';
import { MapDialogComponent } from './components/map-dialog/map-dialog.component';
import { MapResultListMapComponent } from './components/map-result-list/map-result-list.component';
import { MapToggleButtonComponent } from './components/map-toggle-button/map-toggle-button.component';
import { MapComponent } from './components/map/map.component';
import { MapTransformService } from './services/map-transform.service';
import { MapEffects, mapReducer } from './store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatButtonToggleModule,
    NgxMapboxGLModule.withConfig({
      accessToken: 'pk.eyJ1IjoidGVuZ3JvdXAiLCJhIjoiY2prMHU0ZDlxMDl0MTNycXU4N2tzZ3l0dSJ9.IGkqGIcDpRwKrGnNxMhTcQ',
    }),
    MatIconModule,
    TranslateModule,
    StoreModule.forFeature('map', mapReducer),
    EffectsModule.forFeature([MapEffects]),
    MatDialogModule,
    MapComponent,
    MapDialogComponent,
    MapResultListMapComponent,
    MapToggleButtonComponent,
  ],
  providers: [MapTransformService],
  exports: [MapComponent, MapDialogComponent, MapResultListMapComponent, MapToggleButtonComponent],
})
export class MapModule {}
